import React from 'react'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch, renderComponentsSwitch} from '../../utils/contentRenderer'
import {getHideStyles} from '../../utils/utils'

const ContentWrapperBlock = ({
    BackgroundColorPicker,
    Content,
    ContentWrapperBlockPaddingPerDevice,
    HideOnDevices,
    ...props
}) => {
    const hideStyles = getHideStyles(HideOnDevices)
    const styles = useMultiStyleConfig('ContentWrapperBlock', {...props})

    if (hideStyles.doNotLoadComponent) return null

    const getPaddingStyles = (customPadding) => {
        // Only apply padding if custom values are provided
        const paddingValues = {}

        if (customPadding?.PaddingMobile && customPadding.PaddingMobile !== '') {
            paddingValues.base = customPadding.PaddingMobile
        }

        if (customPadding?.PaddingTablet && customPadding.PaddingTablet !== '') {
            paddingValues.md = customPadding.PaddingTablet
        }

        if (customPadding?.PaddingDesktop && customPadding.PaddingDesktop !== '') {
            paddingValues.lg = customPadding.PaddingDesktop
        }

        // Only return padding object if at least one value is set
        return Object.keys(paddingValues).length > 0 ? {padding: paddingValues} : {}
    }

    const paddingStyles = getPaddingStyles(ContentWrapperBlockPaddingPerDevice)

    return (
        <Box
            data-block-type="ContentWrapperBlock"
            {...styles.container}
            {...hideStyles}
            backgroundColor={BackgroundColorPicker}
            {...paddingStyles}
        >
            {Content?.map((item, index) => {
                const expandedContent = item?.ContentLink?.Expanded
                if (!expandedContent) return null

                // Check if it's a CtaItemBlock that should be centered
                const isCtaItemBlock = expandedContent.__typename === 'CtaItemBlock'
                const alignment = expandedContent?.Alignment
                const shouldCenter = isCtaItemBlock && alignment && alignment.includes('center')

                return (
                    <Box
                        key={`${expandedContent.__typename}-${
                            expandedContent.ContentLink?.Id || index
                        }`}
                        display={shouldCenter ? 'flex' : 'block'}
                        justifyContent={shouldCenter ? 'center' : 'flex-start'}
                        textAlign={shouldCenter ? 'center' : 'left'}
                        width="100%"
                    >
                        {renderLayoutsSwitch(expandedContent) ||
                            renderComponentsSwitch(expandedContent)}
                    </Box>
                )
            })}
        </Box>
    )
}

ContentWrapperBlock.propTypes = {
    BackgroundColorPicker: PropTypes.string,
    Content: PropTypes.arrayOf(
        PropTypes.shape({
            ContentLink: PropTypes.shape({
                Expanded: PropTypes.object
            })
        })
    ),
    ContentWrapperBlockPaddingPerDevice: PropTypes.shape({
        PaddingMobile: PropTypes.string,
        PaddingTablet: PropTypes.string,
        PaddingDesktop: PropTypes.string
    }),
    HideOnDevices: PropTypes.string
}

export default ContentWrapperBlock
